import { useEffect, useRef } from 'react';

/**
 * Publishes a fixed strip's height as a CSS variable so sticky layout can sit below it.
 * `active` must be the same condition that mounts the measured node. ResizeObserver
 * tracks wrap, so callers do not re-run this when the strip's text changes.
 */
export const useFixedBannerHeight = (cssVariable: string, active: boolean) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!active) {
      return;
    }
    const node = ref.current;
    if (!node) {
      return;
    }
    const apply = () => {
      document.documentElement.style.setProperty(cssVariable, `${node.offsetHeight}px`);
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(node);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(cssVariable);
    };
  }, [active, cssVariable]);

  return ref;
};
